module.exports = __webpack_public_path__ + "img/erweima_zc.246e0944.jpg";